import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {KahpooReverseService} from "../../../../services/kahpooreverse.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {KahpooReverse} from "../../../../models/kahpooReverse.model";
import {OrderService} from "../../../../services/order.service";
import {environment} from "../../../../environments/environment";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-seller-reversements',
  templateUrl: './seller-reversements.component.html',
  styleUrls: ['./seller-reversements.component.scss']
})
export class SellerReversementsComponent implements OnInit {
  currentSeller:any;
  sumReverse = 0;
  newReverse = [];
  reverses = [];
  orders : any[];
  reverseDone = [];
  transactionReverses = [];
  depots = [];
  reversemementSelected: KahpooReverse;
  transactionForm: FormGroup;

  // 👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- file input
  url: any;
  msg!: string;
  test = false;
  image: any;
  url_photo: any;

  constructor(private kahpooReverseService:KahpooReverseService, private fb: FormBuilder,
              private authService: AuthService,private orderService:OrderService, private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.url_photo = environment.url_photo;
      this.currentSeller = JSON.parse(localStorage.getItem('currentSeller'));
      this.transactionReverses =this.currentSeller.reversements;
      this.depots =this.currentSeller.depots;
      this.loadReverseDone(this.currentSeller.id);
      this.loadNewReverses(this.currentSeller.id);
      this.transactionForm = this.fb.group({
        transactionDoneBy: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]],
        transactionNumber: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]],
        referenceTransaction: ['', Validators.required]
      });
    },error=>{
      this.router.navigate(['/login']);
    });

  }

  selectReverse(reverse: any) {
    this.reversemementSelected = reverse;
  }

  onEditReverseNumber(id: any){
   // console.log(this.currentSeller);
    this.form = this.fb.group({
      paymentMethod: [this.currentSeller.paymentMethod, [Validators.required]],
      paymentMethodDetails: [this.currentSeller.paymentMethodDetails, [Validators.required]],
    });
  }

  form = this.fb.group({
    paymentMethod: ['', [Validators.required]],
    paymentMethodDetails: ['', [Validators.required]],
  });


  onEditReverseNumberSubmit() {
    let userId = this.currentSeller.id;
    let paymentMethod = this.form.controls['paymentMethod'].value;
    let reverseNumber = this.form.controls['paymentMethodDetails'].value;
    let sessionId = localStorage.getItem("kapo_session_id");
    // console.log("userId : "+userId);
    // console.log("paymentMethod : "+paymentMethod);
    // console.log("reverseNumber : "+reverseNumber);
    this.kahpooReverseService.updateUserReverseNumber(sessionId, userId, paymentMethod, reverseNumber).subscribe(rs=>{
        if(rs.paymentMethod==='Mobile money'){
          this.currentSeller.paymentMethodDetails = rs.crypto;
          this.currentSeller.paymentMethod = 'Mobile money';
        }else if(rs.paymentMethod==='Virement'){
          this.currentSeller.paymentMethodDetails = rs.paymentMethodBank;
          this.currentSeller.paymentMethod = 'Virement';
        }else{
          this.currentSeller.paymentMethodDetails = rs.paypalEmail;
          this.currentSeller.paymentMethod = "PayPal";
        }
        
        localStorage.setItem('currentSeller', JSON.stringify(this.currentSeller));
        this.reloadComponent();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Numéro de revsersement Modifié avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
      }, error => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        })
      }
    )
  }

  loadReverseDone(id:any) {
    this.kahpooReverseService.findUserReversementDone(id).subscribe(rs=> {
      this.reverseDone =rs;
    })
  }

  loadNewReverses(id:any) {
    this.kahpooReverseService.findUserNewReversement(id).subscribe(rs=> {
      this.newReverse =rs;
     // console.log(this.newReverse)
      if(this.newReverse != null) {
        this.newReverse.forEach(value => {
          this.sumReverse += value.amount;
        })
      }
    })
  }

  confirmReverse(reverse:any) {
    this.reversemementSelected = reverse;
    //console.log(reverse);
  }

  get transactionDoneBy() {
    return this.transactionForm.get('transactionDoneBy');
  }

  get transactionNumber() {
    return this.transactionForm.get('transactionNumber');
  }

  onSubmit() {
    this.reversemementSelected.transactionDoneBy = this.transactionForm.controls['transactionDoneBy'].value;
    this.reversemementSelected.transactionNumber = this.transactionForm.controls['transactionNumber'].value;
    this.reversemementSelected.referenceTransaction = this.url;
    //console.log(this.reversemementSelected);
    this.kahpooReverseService.validReversement(this.reversemementSelected).subscribe(rs => {
     // console.log(rs);
    })
  }

  selectFile(event: any, i: number) {
    let urlPath: any;
    // Angular 11, for stricter type
    const mimeType = event.target.files[0].type;
   // console.log(event.target.files);
    const sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      this.msg = 'Selectionner une photo';
    }
    // console.log('size!!!!!');
    // console.log(sizeFile);
    if (sizeFile < 2000000) {
     // console.log(mimeType);

      if (mimeType === 'image/jpeg' || mimeType === 'image/jpg'  || mimeType === 'image/svg' || mimeType === 'image/svg+xml' || mimeType === 'image/png') {

        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = '';
          this.url = reader.result;
        };
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = 'Ce type de fichier n\'est pas pris en compte.';
          this.url = reader.result;
          this.test = false;
        };
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msg = 'La taille de l\'image est trop grande';
        this.url = reader.result;
        this.image = this.url;
        this.test = false;
        //console.log( this.url);
      };
    }
  }

  detailOrder(orderID: any) {
    this.orderService.getIdOrderByOrderID(orderID).subscribe(rsp => {
      // console.log(rsp);
    })
  }

  listVentes(reverse) {
    this.orders = [];
    this.reversemementSelected = reverse;
    const processedOrderIDs = new Set(); // Set pour stocker les orderID déjà traités

    this.kahpooReverseService.findUserReversementVentes(reverse.id).subscribe((rs: any[]) => {
        // console.log("Liste des ventes effectuées ....");
        // console.log(rs);

        rs.forEach(value => {
            if (!processedOrderIDs.has(value.orderID)) { // Vérifie si l'orderID n'a pas encore été traité
                processedOrderIDs.add(value.orderID); // Ajoute l'orderID au Set pour éviter les appels redondants

                this.orderService.findOrderItemsByOrderIDAndUserId(value.orderID, this.currentSeller.id).subscribe(rsp => {
                    rsp.forEach(orderItem => {
                        // Vérifie si l'orderItem n'est pas déjà dans la liste this.orders
                        const alreadyExists = this.orders.some(existingOrder => existingOrder.orderItemID === orderItem.orderItemID);
                        if (!alreadyExists) {
                            this.orders.push(orderItem);
                        }
                    });
                });
            }
        });
        // console.log("Liste final...");
        // console.log(this.orders);
    });
  }


  listVentes_old(reverse) {
    this.orders = [];
    this.reversemementSelected = reverse;
    this.kahpooReverseService.findUserReversementVentes(reverse.id).subscribe((rs: any[]) => {
    //  console.log("Liste des ventes effectuées ....");
    //  console.log(rs);
      rs.forEach(value => {
        this.orderService.findOrderItemsByOrderIDAndUserId(value.orderID, this.currentSeller.id).subscribe(rsp => {
          let find = false;
          this.orders.forEach(value1 => {
              if (value1.orderItemID === rsp.orderItemID) {
                find = true;
              }
          });
          if (!find) {
            this.orders.push(rsp)
          }
        })
        // this.orderService.getIdOrderByOrderID(value.orderID).subscribe(rsp => {
        //   let find = false;
        //   this.orders.forEach(value1 => {
        //       if (value1.orderID === rsp.orderID) {
        //         find = true;
        //       }
        //   });
        //   if (!find) {
        //     this.orders.push(rsp)
        //   }
        // })
      })
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }
}
